import { zodResolver } from "@hookform/resolvers/zod";
import { Tag } from "lucide-react";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useBuInstanceLabel, useUpdateBuInstanceLabel } from "@/hooks/use-bu-instance-label";
import {
  type UpdateBuInstanceLabelInput,
  updateBuInstanceLabelSchema,
} from "@/schemas/bu-instance-label-settings";

export function SettingsSystemTab() {
  const { label } = useBuInstanceLabel();
  const updateLabel = useUpdateBuInstanceLabel();

  const form = useForm<UpdateBuInstanceLabelInput>({
    resolver: zodResolver(updateBuInstanceLabelSchema),
    values: { label },
  });

  function onSubmit(values: UpdateBuInstanceLabelInput) {
    updateLabel.mutate(values.label);
  }

  return (
    <div className="space-y-6">
      <Card className="border-border/50">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg">
            <Tag className="h-4 w-4 text-primary" />
            Terminology
          </CardTitle>
          <CardDescription>
            The term used throughout the app for a Coach Manager Business Unit connection. Changing
            this updates every screen immediately — no code deploy needed.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 max-w-sm">
              <FormField
                control={form.control}
                name="label"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Term for BU Instance</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                    <FormDescription>
                      The plural form is generated automatically by appending "s".
                    </FormDescription>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button type="submit" disabled={updateLabel.isPending}>
                {updateLabel.isPending ? "Saving..." : "Save changes"}
              </Button>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
}
